import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../component/Footer';
import { Header } from '../component/Header';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#FFFDE1] font-sans text-zinc-900">
      {/* Navigation */}
      <Header/>

      <div className="max-w-3xl mx-auto px-6 py-16">
        <header className="mb-12">
          <div className="inline-block px-3 py-1 bg-[#ef3a5d] text-white text-[10px] font-bold uppercase tracking-widest mb-4">
            Legal / TOS
          </div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight uppercase leading-none mb-4">
            Terms of Service
          </h1>
          <p className="text-zinc-500 font-mono text-xs uppercase tracking-widest">
            Last Updated: Jan 01, 2026
          </p>
        </header>

        <main className="space-y-10 prose prose-zinc max-w-none">
          <section>
            <h2 className="text-xl font-black uppercase tracking-tight flex items-center gap-2">
              <span className="text-[#ef3a5d]">01.</span> The Agreement
            </h2>
            <div className="h-1 w-10 bg-zinc-900 mb-4"></div>
            <p className="text-zinc-600 leading-relaxed">
              Welcome to Discownty. By accessing our platform or using our "Savings Pool" loyalty system, you agree to these Terms of Service. These terms govern your relationship with Discownty and our partner restaurants.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase tracking-tight flex items-center gap-2">
              <span className="text-[#ef3a5d]">02.</span> Eligibility & Account
            </h2>
            <div className="h-1 w-10 bg-zinc-900 mb-4"></div>
            <p className="text-zinc-600 leading-relaxed">
              You must provide accurate information (Name/ID) at participating restaurants to build your reward chains. You are responsible for any activity associated with your customer profile. Discownty is currently intended for users aged 13 and above.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase tracking-tight flex items-center gap-2">
              <span className="text-[#ef3a5d]">03.</span> The "Savings Pool" System
            </h2>
            <div className="h-1 w-10 bg-zinc-900 mb-4"></div>
            <p className="text-zinc-600 leading-relaxed">
              Rewards are accumulated as a "Savings Pool" based on your spending at specific partner restaurants. These pools are:
            </p>
            <ul className="list-disc pl-5 text-zinc-600 mt-2 space-y-2 italic">
              <li>Non-transferable between different restaurant chains.</li>
              <li>Redeemable only upon reaching the "Milestone Visit" (e.g., the 6th visit).</li>
              <li>Subject to the individual restaurant's participation status.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase tracking-tight flex items-center gap-2">
              <span className="text-[#ef3a5d]">04.</span> Partner Responsibilities
            </h2>
            <div className="h-1 w-10 bg-zinc-900 mb-4"></div>
            <p className="text-zinc-600 leading-relaxed">
              Discownty acts as a technology facilitator. While we track your rewards, the actual fulfillment of the discount is the responsibility of the restaurant partner. We do not provide financial services or cash-back outside of restaurant credit.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black uppercase tracking-tight flex items-center gap-2">
              <span className="text-[#ef3a5d]">05.</span> Termination
            </h2>
            <div className="h-1 w-10 bg-zinc-900 mb-4"></div>
            <p className="text-zinc-600 leading-relaxed">
              We reserve the right to suspend access to the platform or void reward pools if fraudulent activity is detected, such as "checking in" without a legitimate purchase.
            </p>
          </section>

          <section className="bg-zinc-900 text-white p-8 rounded-2xl">
            <h2 className="text-xl font-black uppercase tracking-tight mb-4">
              Questions?
            </h2>
            <p className="text-zinc-400 text-sm mb-4">
              Reach out to our support team for any reward-related queries.
            </p>
            <a href="mailto:info@discownty.com" className="text-[#ef3a5d] font-bold hover:underline">
              info@discownty.com
            </a>
          </section>
        </main>
      </div>

      {/* Footer */}
     <Footer/>
    </div>
  );
};

export default TermsOfService;